import React from 'react';
import { DraggableListItem } from '@campfire/draggable-list';
import { Box, IconButton } from '@material-ui/core';
import { Close } from '@material-ui/icons';
import { FormListItemContext } from './FormListItemContext';
import { FormItem } from './FormItem';

interface Props {
  formItemId: string;
  index: number;
}

export const FormListItem = (props: Props) => {
  const { formItemId, index } = props;
  const { formItems, setFieldValue, draggingId } = React.useContext(FormListItemContext);
  const data = formItems.byId[formItemId];
  const isInsideOption = Boolean(formItems.byTriggerOption[formItemId]);
  const isDragging = formItemId === draggingId;
  const onRemoveFormTriggerItem = (itemId: string) => {
    const optionId = formItems.byTriggerOption[itemId];

    setFieldValue('formItems', {
      ...formItems,
      byTrigger: {
        ...formItems.byTrigger,
        [optionId]: {
          ...formItems.byTrigger[optionId],
          triggerItemIds: formItems.byTrigger[optionId].triggerItemIds.filter(
            (triggerItemId) => triggerItemId !== itemId
          ),
        },
      },
      byTriggerOption: {
        ...formItems.byTriggerOption,
        [itemId]: undefined,
      },
    });
  };

  return (
    <DraggableListItem id={formItemId} index={index} style={isDragging ? { height: '2rem', maxWidth: '100%' } : {}}>
      <Box display='flex' width='100%' alignItems='center'>
        <FormItem data={data} />
        {isInsideOption && (
          <IconButton onClick={() => onRemoveFormTriggerItem(formItemId)}>
            <Close />
          </IconButton>
        )}
      </Box>
    </DraggableListItem>
  );
};
